import React, { Dispatch, ReactNode, SetStateAction } from 'react';
import { SiteSubjectType, Visits } from '@dynamika-shared/types/subjects';
import {
  PolingResponse,
  UploadStatus,
  VerificationStepsItem,
} from 'src/store-redux/siteUpload/siteUploadStore.types';
import { JsonSchema, UISchemaElement } from '@jsonforms/core';
import { ExpandedData } from '@restore/clinicalTrialContext/clinicalTrialContext.types';

export enum CheckStatus {
  NO_VALIDATED = 'NO_VALIDATED',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  RESOLVED = 'RESOLVED',
}

export enum UploadDrawerStep {
  VisitStep = 0,
  EdtfStep = 1,
  FileUploadStep = 2,
  FileValidationStep = 3,
}

export enum CheckStatusTitleEnum {
  SUCCESS = 'Success',
  WARNING = 'Warning',
  RESOLVED = 'Resolved',
  LOADING = 'Loading',
  NO_VALIDATED = 'Cannot validate',
}

export type SignedUrlType = { signedUrl: string };

export enum VisitDefinitionsStatusText {
  CLOSED = ' Ended Visit',
  IN_PROGRESS = 'Uploaded',
  CREATED = 'Created',
}

export enum VisitDefinitionsStatus {
  CLOSED = 'CLOSED',
  IN_PROGRESS = 'IN_PROGRESS',
  CREATED = 'CREATED',
}

export type DefaultOptionType = {
  value: string;
  disabled: boolean;
  label: JSX.Element;
  desc: JSX.Element;
  id: string;
  baseline: number;
  closed: boolean;
};

export interface ExtendedVisit extends Visits {
  value: string;
  daysFromBaseline: number;
}

export interface VisitDropdown extends Visits {
  value: string;
  disabled: boolean;
  label: ReactNode;
  desc: ReactNode;
  baseline: number | null;
  closed: boolean;
  createUnscheduled?: boolean;
}

export const CheckStatusToTitleMap: Record<CheckStatus, CheckStatusTitleEnum> =
  {
    [CheckStatus.SUCCESS]: CheckStatusTitleEnum.SUCCESS,
    [CheckStatus.WARNING]: CheckStatusTitleEnum.WARNING,
    [CheckStatus.RESOLVED]: CheckStatusTitleEnum.RESOLVED,
    [CheckStatus.NO_VALIDATED]: CheckStatusTitleEnum.NO_VALIDATED,
    [CheckStatus.LOADING]: CheckStatusTitleEnum.LOADING,
  };

export const CheckStatusTitle: Record<
  CheckStatus | CheckStatusTitleEnum,
  string
> = {
  [CheckStatus.NO_VALIDATED]: 'Cannot validate',
  [CheckStatus.LOADING]: 'Loading',
  [CheckStatus.SUCCESS]: 'Success',
  [CheckStatus.WARNING]: 'Warning',
  [CheckStatus.RESOLVED]: 'Resolved',
  [CheckStatusTitleEnum.SUCCESS]: 'Success',
  [CheckStatusTitleEnum.WARNING]: 'Warning',
  [CheckStatusTitleEnum.RESOLVED]: 'Resolved',
  [CheckStatusTitleEnum.LOADING]: 'Loading',
  [CheckStatusTitleEnum.NO_VALIDATED]: 'Cannot validate',
};

export enum StatusCodes {
  OK = 200,
}

export type UploadFormData = {
  description: string;
  id: string;
  modalityNames: string[];
  schema: JsonSchema;
  uiSchema: UISchemaElement & { formType?: 'VS' };
};

export enum PolingStatus {
  PREPROCESSING = 'PREPROCESSING',
  FAILED = 'FAILED',
  DELETED = 'DELETED',
  VALIDATED = 'VALIDATED',
  ANONYMIZED = 'ANONYMIZED',
  COMPLETE = 'COMPLETE',
}
export enum PreprocessingStatus {
  CREATED = 'CREATED',
  UPLOADED = 'UPLOADED',
  PARSING_FAILED = 'PARSING_FAILED',
  PREFILLED = 'PREFILLED',
  NOT_VALID = 'NOT_VALID',
  VALIDATED = 'VALIDATED',
}

export interface StepComponentProps {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  currentStep: number;
  data: ExpandedData | null;
  subject: SiteSubjectType | null | undefined;
  file: File | null | undefined;
  setFile: (file: File | null) => void;
  setDisableConfirmUpload: (value: boolean) => void;
  setVerificationStepsData: Dispatch<
    SetStateAction<Partial<VerificationStepsItem>[] | undefined>
  >;
  verificationStepsData: Partial<VerificationStepsItem>[] | undefined;
  polingData: PolingResponse | null | undefined;
  setAdditionalComment: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  setDirtyDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  setVisitName: Dispatch<SetStateAction<string | null | undefined>>;
  setStatus: (status: UploadStatus) => void;
  setReuploadDrawer: React.Dispatch<React.SetStateAction<boolean>>;
}
